import { render } from "./Batch.vue?vue&type=template&id=5da568cc&scoped=true"
import script from "./Batch.vue?vue&type=script&lang=js"
export * from "./Batch.vue?vue&type=script&lang=js"

import "./Batch.vue?vue&type=style&index=0&id=5da568cc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da568cc"]])

export default __exports__